import moment from 'moment';
import {
  CORREDOR_GP_CHANGE_FILTER_DATE,
  CORREDOR_GP_CHANGE_PROD_MENSUAL_FILTER_DATE,
  CORREDOR_GP_GET_LIST,
  CORREDOR_GP_GET_PROD_MENSUAL,
  CORREDOR_GP_GET_PROD_MENSUAL_SUMMARY,
  CORREDOR_GP_GET_SUMMARY,
  CORREDOR_GP_UPDATE_LIST_URLS,
  CORREDOR_GP_UPDATE_PROD_MENSUAL_LIST_URLS,
  GP_GET_TIPOS_ENDOSO,
  startType,
} from '../constants/action-types';
import { DEFAULT_PAGE_SIZE } from '../../CONST';


const initialState = {
  tiposEndoso: [],
  list: {
    endosos: {
      data: [],
      fetchedUrl: '',
      pages: 0,
      count: 0,
      next: '',
      previous: '',
    },
    datesFilter: {
      startDate: moment(),
      endDate: moment(),
    },
    summary: null,
    xlsxUrl: '',
    pdfUrl: '',
  },
  prodMensual: {
    list: [],
    datesFilter: {
      startDate: moment().startOf('year'),
      endDate: moment(),
    },
    summary: null,
    xlsxUrl: '',
    pdfUrl: '',
  },
  loading: false,
};

const initLoading = state => ({
  ...state,
  loading: true,
});

const getList = (state, action) => ({
  ...state,
  loading: false,
  list: {
    ...state.list,
    endosos: {
      ...state.list.endosos,
      data: action.payload.results,
      pages: Math.ceil(action.payload.count / DEFAULT_PAGE_SIZE),
      count: action.payload.count,
      next: action.payload.next,
      previous: action.payload.previous,
    },
  },
});

const changeFilterDate = (state, action) => ({
  ...state,
  list: {
    ...state.list,
    datesFilter: {
      ...state.list.datesFilter,
      [action.payload.fieldName]: action.payload.value
    },
  },
});

const getSummary = (state, action) => ({
  ...state,
  list: {
    ...state.list,
    summary: action.payload,
  },
});

const updateListUrls = (state, action) => ({
  ...state,
  list: {
    ...state.list,
    ...action.payload,
  },
});

const getProdMensual = (state, action) => ({
  ...state,
  loading: false,
  prodMensual: {
    ...state.prodMensual,
    list: action.payload,
  },
});

const getProdMensualSummary = (state, action) => ({
  ...state,
  prodMensual: {
    ...state.prodMensual,
    summary: action.payload,
  },
});

const changeProdMensualFilterDate = (state, action) => ({
  ...state,
  prodMensual: {
    ...state.prodMensual,
    datesFilter: {
      ...state.prodMensual.datesFilter,
      [action.payload.fieldName]: action.payload.value
    },
  },
});

const updateProdMensualListUrls = (state, action) => ({
  ...state,
  prodMensual: {
    ...state.prodMensual,
    ...action.payload,
  },
});

const getTiposEndoso = (state, action) => ({
  ...state,
  tiposEndoso: action.payload,
});


function corredorGarantia(state = initialState, action) {
  switch (action.type) {
    case startType(CORREDOR_GP_GET_LIST):
      return initLoading(state);
    case CORREDOR_GP_GET_LIST:
      return getList(state, action);
    case CORREDOR_GP_CHANGE_FILTER_DATE:
      return changeFilterDate(state, action);
    case CORREDOR_GP_GET_SUMMARY:
      return getSummary(state, action);
    case CORREDOR_GP_UPDATE_LIST_URLS:
      return updateListUrls(state, action);
    case startType(CORREDOR_GP_GET_PROD_MENSUAL):
      return initLoading(state);
    case CORREDOR_GP_GET_PROD_MENSUAL:
      return getProdMensual(state, action);
    case CORREDOR_GP_GET_PROD_MENSUAL_SUMMARY:
      return getProdMensualSummary(state, action);
    case CORREDOR_GP_CHANGE_PROD_MENSUAL_FILTER_DATE:
      return changeProdMensualFilterDate(state, action);
    case CORREDOR_GP_UPDATE_PROD_MENSUAL_LIST_URLS:
      return updateProdMensualListUrls(state, action);
    case GP_GET_TIPOS_ENDOSO:
      return getTiposEndoso(state, action);
    default:
      return state;
  }
}

export default corredorGarantia;
